/**
 * OVERRIDE View.jsx
 * REASON: Adding variants.
 * VERSION: 6.3.1
 * DATE: 2025-07-18
 * DEVELOPER: @Tishasoumya-02
 */

import View from '../../../../components/Blocks/Slider/View';

export default View;
